export default "__VITE_ASSET__a7d212dc__"